import { Component } from '@angular/core';

@Component({
  selector: 'app-ncarb-login-dialogue',
  templateUrl: './ncarb-login-dialogue.html',
  styleUrls: ['./ncarb-login-dialogue.scss'],
})
export class NcarbLoginDialogue {}
